export const config = {
  apiBaseUrl: 'https://chz1yzlddg.execute-api.us-east-1.amazonaws.com/prod',
  stripePublicKey:
    'pk_live_51S0YrIPyiM7Fj0JorTU3peJt3d0jqwApLCumGmZ3S4ajfSm5GiAVPlYTkeVagODQKQSgbJZcMgESYKI3NHq2lURw00hGK2KfeP',
  environment: 'production',
};
